export interface SecurityProjectDetailsInput {
  projectId: string;
  rootDependency?: boolean;
}
